import { render, staticRenderFns } from "./documentsList.vue?vue&type=template&id=13690b9f"
import script from "./documentsList.vue?vue&type=script&lang=js"
export * from "./documentsList.vue?vue&type=script&lang=js"
import style0 from "./documentsList.vue?vue&type=style&index=0&id=13690b9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports